import React, { useState, useEffect, useRef } from 'react';
import { Route, withRouter } from 'react-router-dom';

import { useProfileService } from 'src/services/ProfileService';
import { useTranslationService } from 'src/services/TranslationService';
import { useModalService } from 'src/services/ModalService';

// Utils
import { checkProfile } from 'src/utils/profile';

// Components
import { GeneralLoading } from 'src/components/common/general-loading/GeneralLoading';

// Modals
import SuccessModal from 'src/components/modals/Success';
import ErrorModal from 'src/components/modals/Error';

// Api
import { userMe } from 'src/api/authentication';

const _PrivateRoute = ({
    component: Component,
    ...rest
}) => {
    const { profile, setProfileData } = useProfileService();
    const { setLanguage, loadingLanguage } = useTranslationService();
    const [checkAuthenticated, setCheckAuthenticated] = useState(false);
    const isAuthenticated = checkProfile(profile);
    const { modals } = useModalService();

    const mountedComponentRef = useRef(true);

    useEffect(() => {
        if (isAuthenticated) {
            if (mountedComponentRef.current) {
                setCheckAuthenticated(true);
            }
        } else {
            userMe().then((response) => {
                if (mountedComponentRef.current) {
                    setProfileData({...response});
                    setLanguage(response.locale);
                    setCheckAuthenticated(true);
                }
            }).catch(() => {
                if (mountedComponentRef.current) {
                    goToLogin();
                }
            });
        }

        return () => {
            mountedComponentRef.current = false
        }
    }, [profile]);

    const goToLogin = () => {
        rest.history.push('/login');
    };

    return (
        <Route
            {...rest}
            render={
                (props) => ((checkAuthenticated && !loadingLanguage)
                    ? (
                        (isAuthenticated)
                        && (
                            <>
                                <Component {...props} {...rest}  />

                                {(modals && modals.current === 'success') && <SuccessModal show/>}
                                {(modals && modals.current === 'error') && <ErrorModal show/>}
                            </>
                        )
                    ) : <GeneralLoading fullScreen />)
            }
        />
    );
};

export const PrivateRoute = withRouter(_PrivateRoute);
